// extracted by mini-css-extract-plugin
var _1 = "EntityProfileTabUpdatesCardHeader-moduleEntityProfileTabUpdatesCardHeader__j6ujH";
var _2 = "EntityProfileTabUpdatesCardHeader-moduletimestamp__tjGak";
export { _1 as "EntityProfileTabUpdatesCardHeader", _2 as "timestamp" }
